import Theme from '../../../../../../../Theme';

export const ROOM_ITEM_BACKGROUND_COLOR_WITH_NOTIFICATION = Theme.palette.background.default;

export const ROOM_ITEM_BACKGROUND_COLOR_WITHOUT_NOTIFICATION = Theme.palette.common.white;

export const CHAT_CONFIG_VIEW_CONTENT_HEIGHT = '366px';

export const CHAT_FOOTER_HEIGHT = '64px';
